<template>
  <main>
    <section class="sticky w-full top-0 z-10 bg-greyBackground pb-4">
      <article class="flex justify-between pb-4 pt-8 items-center md:justify-center">
        <router-link
          v-if="($route.meta.showBackArrow && $route.meta.displayName) || ($route.meta.showBackArrow && $route.params.name)"
          :to="{
            name: $route.query.redirectBackTo || $route.meta.redirectBackTo,
          }"
        >
          <div class="flex gap-2 items-baseline"  @click="$route">
            <img
              v-if="$route.meta.showBackArrow"
              class="h-4 w-4 md:hidden"
              src="../assets/primary-left-arrow.svg"
              alt="ePayLater"
            />
            <h1 v-if="$route.meta.displayName" class="justify-self-center heading-text">
              {{ $route.meta.displayName }}
            </h1>
            <h1 v-else-if="$route.params.name" class="justify-self-center heading-text">
              {{ $route.params.name }}
            </h1>
          </div>
        </router-link>
        <div v-else class="flex gap-2 items-baseline"  @click="$route">
          <h1 v-if="$route.meta.displayName" class="justify-self-center heading-text">
            {{ $route.meta.displayName }}
          </h1>
          <h1 v-else-if="$route.params.name" class="justify-self-center heading-text">
            {{ $route.params.name }}
          </h1>
        </div>
        <img
          class="block h-5 md:h-8 w-auto md:hidden"
          src="../assets/logo-primary.svg"
          alt="ePayLater"
          width="132"
          height="28"
        />
      </article>
      <div class="flex left-0 w-full items-center">
        <span
          v-for="index in $route.meta.totalSteps"
          :key="index"
          class="w-full contents"
        >
          <div
            :class="index > $route.meta.currentStep ? 'circleWithNumber bg-transparent flex p-2 h-2 rounded-full items-center justify-center text-xs text-greySteps' :
             'bg-primaryLight text-white flex p-2 h-5 rounded-full items-center justify-center text-xs text-center'"
          >
            {{index}}
          </div>
          <span
            v-if="index < $route.meta.totalSteps"
            :class="index > $route.meta.currentStep - 1 ? 'bg-greySteps heightLine w-full': 'w-full h-1 bg-primaryLight'"
          ></span>
        </span>
      </div>
    </section>
    <section
      class="pb-4 min-h-form content-start gap-4 relative items-start w-full"
    >
      <router-view></router-view>
    </section>
  </main>
</template>
<script>

export default {
  components: {
  },
  name: 'PreApprovalLayout',
  mounted() {
    this.init();
  },
  data() {
    return {
    };
  },
  methods: {
    init() {
    },
  },
};
</script>
<style lang="scss">
 .circleWithNumber {
    background: transparent;
    border: 2px solid #DEDEDE;
  }
  .heightLine {
    height: 0.15rem;
  }
</style>
